"use client";

import { FC, useState } from "react";
import { useRouter } from "next/navigation";

import { PrimaryButton } from "~/client/components";
import { getErrorMessage, increment } from "~/shared/utils";
import { ErrorPageProps } from "~/types";

const RootErrorLayout: FC<ErrorPageProps> = ({ error, reset }) => {
	const router = useRouter();
	const [attempts, setAttempts] = useState(0);

	const handleReset = () => {
		if (attempts > 0)
			return router.refresh();

		reset();
		setAttempts(increment);
	};

	return (
		<html lang="en">
			<head></head>
			<body>
				<div>
					<h1>Error - something went wrong!</h1>
					<p>{getErrorMessage(error)}</p>
				</div>
				<div>
					<PrimaryButton onClick={handleReset}>
						Try again
					</PrimaryButton>
				</div>
			</body>
		</html>
	);
};

export default RootErrorLayout;